export default async function CreateScalesApi(
    name,
    unitName,
    abbreviation,
    symbol
  ) {
    let res = "";
    try {
      const body = {
        name: name,
        unitName: unitName,
        abbreviation: abbreviation,
        symbol: symbol
      };
      const token = "Bearer " + localStorage.getItem("authToken");
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: token,
        },
        body: JSON.stringify(body),
      };
      await fetch(
        `${process.env.REACT_APP_API_URL}v1/scales/scale-both`,
        requestOptions
      )
        .then((response) => response.json())
        .then((response) => {
          res = response;
        })
        .catch((error) => {
          console.error("Error create scales: ", error);
          res = error;
        });
    } catch (error) {
      console.error(error);
      res = error;
    }
  
    return res;
  }
  